import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'DialpadOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dialpad-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 7h-4v-4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 3h4v4h-4z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 6v-3h4v4h-3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 10h4v4h-4z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17 13v-3h4v4h-3"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M14 14h-4v-4"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 17h4v4h-4z"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M3 3l18 18"
    }, null), _createTextVNode(" ")]);
  }
};